"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LogoNavigation;
var _react = _interopRequireDefault(require("react"));
var _ImageReplacementAnchor = _interopRequireDefault(require("../utils/ImageReplacementAnchor"));
require("./../../scss/navigations/LogoNavigation.module.scss");
function LogoNavigation(_ref) {
  let {
    items = [],
    height = 4
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("logo-navigation", {
    style: {
      '--logo-nav-max-height': "".concat(height, "rem")
    }
  }, items.length > 0 && items.map(item => {
    var _item$target;
    return /*#__PURE__*/_react.default.createElement(_ImageReplacementAnchor.default, {
      href: item.href,
      target: (_item$target = item === null || item === void 0 ? void 0 : item.target) !== null && _item$target !== void 0 ? _item$target : '_self',
      image: item.image,
      height: item.height,
      baselineAdjustment: item !== null && item !== void 0 && item.baselineAdjustment ? item.baselineAdjustment : 0,
      key: "ira-".concat(Math.round(Math.random() * 10000000)),
      text: item.text
    });
  }));
}